<script>

  import { mapState } from 'vuex'
  import ArticlesList from '@/components/ArticlesList'
  import FetchArticles from '@/middleware/fetch-articles'
  import { HeadMeta } from '@/utils/head-meta'

  export default {
    components: {
      ArticlesList
    },
    middleware: [FetchArticles],
    scrollToTop: true,
    head () {
      return HeadMeta({
        metaTitle: 'Examentips',
        metaDescription: this.config.fields.articlesArchiveDescription
      })
    },
    computed: {
      ...mapState({
        config: state => state.config
      })
    }
  }
</script>

<template>
  <div>
    <articles-list />
  </div>
</template>
